/**
* Intended for pure helper functions that contain NO knowledge of the app architecture. For
* functions that operate based on knowledge of the app architecture, see GlobalMixins.js mixin
*/

const htmlInlineStrips = [
	'onabort',
	'onactivate',
	'onafterprint',
	'onafterscriptexecute',
	'onafterupdate',
	'onanimationcancel',
	'onanimationend',
	'onanimationiteration',
	'onanimationstart',
	'onautocomplete',
	'onautocompleteerror',
	'onauxclick',
	'onbeforeactivate',
	'onbeforecopy',
	'onbeforecut',
	'onbeforedeactivate',
	'onbeforeeditfocus',
	'onbeforeinput',
	'onbeforematch',
	'onbeforepaste',
	'onbeforeprint',
	'onbeforescriptexecute',
	'onbeforetoggle',
	'onbeforeunload',
	'onbeforeupdate',
	'onbeforexrselect',
	'onbegin',
	'onblur',
	'onbounce',
	'oncancel',
	'oncanplay',
	'oncanplaythrough',
	'oncellchange',
	'onchange',
	'onclick',
	'onclose',
	'oncommand',
	'oncontentvisibilityautostatechange',
	'oncontextlost',
	'oncontextmenu',
	'oncontextrestored',
	'oncontrolselect',
	'oncopy',
	'oncuechange',
	'oncut',
	'ondataavailable',
	'ondatasetchanged',
	'ondatasetcomplete',
	'ondblclick',
	'ondeactivate',
	'ondrag',
	'ondragend',
	'ondragenter',
	'ondragexit',
	'ondragleave',
	'ondragover',
	'ondragstart',
	'ondrop',
	'ondurationchange',
	'onemptied',
	'onencrypted',
	'onend',
	'onended',
	'onenterpictureinpicture',
	'onerror',
	'onerrorupdate',
	'onexit',
	'onfilterchange',
	'onfinish',
	'onfocus',
	'onfocusin',
	'onfocusout',
	'onformdata',
	'onfullscreenchange',
	'onfullscreenerror',
	'ongamepadconnected',
	'ongamepaddisconnected',
	'ongotpointercapture',
	'onhashchange',
	'onhelp',
	'oninput',
	'oninvalid',
	'onkeydown',
	'onkeypress',
	'onkeyup',
	'onlanguagechange',
	'onlayoutcomplete',
	'onleavepictureinpicture',
	'onload',
	'onloadeddata',
	'onloadedmetadata',
	'onloadend',
	'onloadstart',
	'onlosecapture',
	'onlostpointercapture',
	'onmessage',
	'onmessageerror',
	'onmousedown',
	'onmouseenter',
	'onmouseleave',
	'onmousemove',
	'onmouseout',
	'onmouseover',
	'onmouseup',
	'onmousewheel',
	'onmove',
	'onmoveend',
	'onmovestart',
	'onmozfullscreenchange',
	'onoffline',
	'ononline',
	'onpagehide',
	'onpagereveal',
	'onpageshow',
	'onpageswap',
	'onpaste',
	'onpause',
	'onplay',
	'onplaying',
	'onpointercancel',
	'onpointerdown',
	'onpointerenter',
	'onpointerleave',
	'onpointerlockchange',
	'onpointerlockerror',
	'onpointermove',
	'onpointerout',
	'onpointerover',
	'onpointerrawupdate',
	'onpointerup',
	'onpopstate',
	'onprogress',
	'onpropertychange',
	'onratechange',
	'onreadystatechange',
	'onrejectionhandled',
	'onrepeat',
	'onreset',
	'onresize',
	'onresizeend',
	'onresizestart',
	'onresume',
	'onrowenter',
	'onrowexit',
	'onrowsdelete',
	'onrowsinserted',
	'onscroll',
	'onscrollend',
	'onsearch',
	'onsecuritypolicyviolation',
	'onseeked',
	'onseeking',
	'onselect',
	'onselectionchange',
	'onselectstart',
	'onshow',
	'onslotchange',
	'onsort',
	'onstalled',
	'onstorage',
	'onsubmit',
	'onsuspend',
	'ontextinput',
	'ontimeupdate',
	'ontoggle',
	'ontouchcancel',
	'ontouchend',
	'ontouchenter',
	'ontouchleave',
	'ontouchmove',
	'ontouchstart',
	'ontransitioncancel',
	'ontransitionend',
	'ontransitionrun',
	'ontransitionstart',
	'onunhandledrejection',
	'onunload',
	'onvolumechange',
	'onwaiting',
	'onwaitingforkey',
	'onwebkitanimationend',
	'onwebkitanimationiteration',
	'onwebkitanimationstart',
	'onwebkitfullscreenchange',
	'onwebkittransitionend',
	'onwheel',
	'javascript:',
]

export default {
	created() {
		let vm = this

		Number.prototype.toCurrency = function() {
			return vm.accounting.formatNumber(this,2,",")
		}

		String.prototype.toCurrency = function() {
			return vm.accounting.formatNumber(+this,2,",")
		}

		String.prototype.toFloat = function() {
			const isNegative = this.trim().startsWith('(') && this.trim().endsWith(')');

			// Remove $, commas, spaces, and parentheses
			let cleaned = this.replace(/[$,\s()]/g, '');

			// Parse the result as a float
			let result = parseFloat(cleaned);

			// Apply negative sign if it was in parentheses
			return isNegative ? -result : result;
		}

		Number.prototype.round = function (precision = 0) {
			return Number(
				Math.round(Number(this + 'e' + precision)) + 'e-' + precision
			);
		};

		Number.prototype.pad = function padDigits(digits) {
		    return Array(Math.max(digits - String(this).length + 1, 0)).join(0) + this;
		}

		Number.prototype.toRadians = function() {
			return this * Math.PI / 180
		}

		Number.prototype.countDecimals = function () {
			if(Math.floor(this.valueOf()) === this.valueOf()) return 0;

			let sections = this.toString().split(".")

			if (sections.length > 0 && !isNaN(sections[1])) 
				return sections[1].length || 0; 

			return 0
		}

		String.prototype.slugify = function() {
			let slug = this.replace(/\s+/g, '-').toLowerCase() //replace spaces with dash
			slug = slug.replace(/\/+/g,'-') //replace slashes with dash
			return slug.replace(/[[\]]+/g,'') //replace brackets with nothing
		}

		String.prototype.firstLetterIsVowel = function() {
			let vowels = ["a","e","i","o","u"];

			let firstLetter = this.substr(0,1).toLowerCase();

			if (vowels.indexOf(firstLetter) >= 0)
				return true	
			else
				return false
		}

		//polyfill for allSettled method
		if (typeof Promise.allSettled == 'undefined') {
			Promise.allSettled = function (promises) {
				let mappedPromises = promises.map((p) => {
				return p
					.then((value) => {
						return {
							status: 'fulfilled',
							value,
						};
						})
						.catch((reason) => {
						return {
							status: 'rejected',
							reason,
						};
					});
				});
				return Promise.all(mappedPromises);
			}
		}

		String.prototype.stripTags = function() {
			let temporalDivElement = document.createElement("div");
			// Set the HTML content with the providen
			temporalDivElement.innerHTML = this;
			// Retrieve the text property of the element (cross-browser support)
			return temporalDivElement.textContent || temporalDivElement.innerText || "";

		}
	},
	computed: {
		companyIsAmerican() {
			return this.statesList.find(state => state.value == this.$store.company.province)
		}
	},
	methods: {
		stripInlineEventHandlers(html) {
			if (html == null)
				return html

			let stripped = String(html)
			let listIndex = 0

			while (listIndex < htmlInlineStrips.length) {
				let item = htmlInlineStrips[listIndex]
				let searchFrom = 0
				listIndex++

				while (searchFrom < stripped.length) {
					let lower = stripped.toLowerCase()
					let foundAt = lower.indexOf(item.toLowerCase(), searchFrom)
					if (foundAt < 0)
						break

					if (item == 'javascript:') {
						let endAt = foundAt + item.length
						while (endAt < stripped.length) {
							let ch = stripped.charAt(endAt)
							if (ch == '"' || ch == "'" || ch == '>' || ch == ' ' || ch == '\t' || ch == '\n' || ch == '\r')
								break
							endAt++
						}
						stripped = stripped.substring(0, foundAt) + stripped.substring(endAt)
						searchFrom = foundAt
						continue
					}

					let charBefore = foundAt == 0 ? '' : stripped.charAt(foundAt - 1)
					let cursor = foundAt + item.length
					while (cursor < stripped.length) {
						let ch = stripped.charAt(cursor)
						if (ch == ' ' || ch == '\t' || ch == '\n' || ch == '\r')
							cursor++
						else
							break
					}

					if (cursor >= stripped.length || stripped.charAt(cursor) != '=') {
						searchFrom = foundAt + 1
						continue
					}

					let isAttribute = (
						foundAt == 0
						|| charBefore == ' '
						|| charBefore == '\t'
						|| charBefore == '\n'
						|| charBefore == '/'
						|| charBefore == '<'
					)
					if (!isAttribute) {
						searchFrom = foundAt + 1
						continue
					}

					cursor++
					while (cursor < stripped.length) {
						let ch = stripped.charAt(cursor)
						if (ch == ' ' || ch == '\t' || ch == '\n' || ch == '\r')
							cursor++
						else
							break
					}

					if (cursor < stripped.length) {
						let quote = stripped.charAt(cursor)
						if (quote == '"' || quote == "'") {
							cursor++
							while (cursor < stripped.length && stripped.charAt(cursor) != quote)
								cursor++
							if (cursor < stripped.length)
								cursor++
						}
						else {
							while (cursor < stripped.length) {
								let ch = stripped.charAt(cursor)
								if (ch == ' ' || ch == '\t' || ch == '>' || ch == '\n' || ch == '\r')
									break
								cursor++
							}
						}
					}

					let startAt = foundAt
					if (charBefore == ' ' || charBefore == '\t' || charBefore == '\n' || charBefore == '/')
						startAt = foundAt - 1

					stripped = stripped.substring(0, startAt) + stripped.substring(cursor)
					searchFrom = startAt
				}
			}

			return stripped
		},
		isset(baseVar,varInStrForm) {
			let segs = varInStrForm.split(".")

			let fail = false
			let builtUpVar = baseVar
			segs.forEach(seg => {
				if (seg in builtUpVar && builtUpVar[seg])
					builtUpVar = builtUpVar[seg]
				else
					fail = true
			})

			return !fail
		},
		isValidJSON(str) {

			if (!str || str.length < 2)
				return false

			try {
				JSON.parse(str)
			}
			catch (e) {
				return false
			}
			return true
		},
		isImageExtension(ext) {
			let imageExtensions = ["png","jpg","jpeg","gif","heic","bmp"]

			return imageExtensions.indexOf(ext) >= 0
		},
		formatDateToSystem(date) { //format required for queries
			if (date)
				return this.moment(date).format("YYYY-MM-DD")
			else
				return "Invalid Date"
		},
		formatDate(date) {
			if (date)
				return this.moment(date).format("MMM D, YYYY")
			else
				return "Invalid Date"
		},
		/**
		* @oaram format options:
		*	'time'
		*	'month-day'
		*	'month-day-time'
		*	'full-date'
		*	'full-date-time'
		*/
		formatDateTimeToLocal(dateTimeUTC,format) {
			let momentDateTime = this.moment.utc(dateTimeUTC)

			if (this.moment(dateTimeUTC).isValid()) {
				let theFormat = "MMM D, YYYY @ h:mm a"

				let noYear = "MMM D"
				let withYear = "MMM D, YYYY"

				let time = "h:mm a"

				if (format == 'time')
					theFormat = time
				else if (format == 'month-day')
					theFormat = noYear
				else if (format == 'month-day-time')
					theFormat = noYear+" "+time
				else if (format == 'full-date')
					theFormat = withYear
				else if (format =='full-date-time')
					theFormat = withYear+" @ "+time
				else if (!format)
					theFormat = withYear+" @ "+time
				else
					theFormat = format

				return momentDateTime.local().format(theFormat)
			}
			else
				return ""
		},
		formatDateTime(dateTimeUTC,format) {
			let momentDateTime = this.moment(dateTimeUTC)

			if (this.moment(dateTimeUTC).isValid()) {
				let theFormat = "MMM D, YYYY @ h:mm a"

				let noYear = "MMM D"
				let withYear = "MMM D, YYYY"

				let time = "h:mm a"

				if (format == 'time')
					theFormat = time
				else if (format == 'month-day')
					theFormat = noYear
				else if (format == 'month-day-time')
					theFormat = noYear+" "+time
				else if (format == 'full-date')
					theFormat = withYear
				else if (format =='full-date-time')
					theFormat = withYear+" @ "+time
				else if (!format)
					theFormat = withYear+" @ "+time
				else
					theFormat = format

				return momentDateTime.local().format(theFormat)
			}
			else
				return ""
		},
		formatTime(date) {
			if (date)
				return this.moment(date).format("h:mm a")
			else
				return "Invalid Date"
		},
		//checks if date is empty (either 0000-00-00 00:00:00 or null)
		dateIsEmpty(date) {
			if (this.moment(date).format("YYYY-MM-DD") == "0000-00-00" || !date || date == "0000-00-00 00:00:00" || date == "0000-00-00")
				return true
			else
				return false
		},
		//return difference between 2 dates
		dateDiff(date1,date2, units) {
			if (units == "hrs") {
				return Math.round(this.moment(date2).diff(date1,"hours",true)*10)/10
			}
			else if (units == "days")
				return this.moment(date2).diff(date1,"days")
			else 
				return Math.floor(( date2 - date1 ) / 86400000);
			
		},
		// Converts a number to a character (ex. 0 -> A, 1 -> B...)
		numAsChar(num) {
			return (num + 9).toString(36).toUpperCase()
		},
		//take an array of objects and turn it into an array compatable for Field component options
		optionify(input, displayField, ignoreId = false) {
			let vm = this

			let returnArray = []

			if (typeof input !== 'undefined') {
				input.forEach(function(item, index){

					let value = item[displayField]
					if ("id" in item && !ignoreId)
						value = item.id

					let option = {
						text: item[displayField],
						value: value
					}

					if ("disabled" in item)
						option.disabled = item.disabled

					returnArray.push(option)
				})	
			}

			return returnArray
		},
		//take an option object array and reduce it to just a simple array
		deoptionify(input) {
			let vm = this

			let returnArray = []
			if (input) {
				input.forEach(function(item, index) {
					returnArray.push(item.value)
				})
			}

			return returnArray
		},

		// Filter an array of objects using the given array of filters in the format
		// [["prop comparator?", value], ... ]      ex. ["expiry_date >=", "2021-04-03"]
		// Note: FOR loops are used here instead of map/filter/foreach, so that a T/F value
		// can be returned directly to the filter (otherwise, a return T/F refers to
		// the map/filter/foreach loop itself and NOT the higher-scoped filter function)
		filterObjects(items, filters) {
			let filtersLength = filters.length

			// Check each item
			return items.filter(item => {

				// Compare item against each filter
				for (let i = 0; i < filtersLength; i++) {
					let refs = filters[i][0].split(' ')
					let val = filters[i][1]
					let prop = refs[0]

					// Value of filter is not a list? Make it a list for easier comparison
					if (typeof(val) != 'object' || val == null || !('length' in val))
						val = [val]

					// Property exists in the item?
					// Check each filter value to see if it matches the item
					if (prop in item) {

						// Base value. Update if match found (ie include in final list)
						let valueMatched = false

						// Loop through each filter value
						for (let j = 0; j < val.length; j++) {

							// Check comparators (>, <, >=, <=)
							if (refs.length > 1) {

								if ((refs[1] == '>' && item[prop] > val[j]) ||
									(refs[1] == '<' && item[prop] < val[j]) ||
									(refs[1] == '>=' && item[prop] >= val[j]) ||
									(refs[1] == '<=' && item[prop] <= val[j]) ||
									(refs[1] == '!=' && item[prop] != val[j])) {
									valueMatched = true
									break
								}

								// Assume we use the comparator (==) looking for substrings
							} else if (item[prop].indexOf(val[j]) != -1) {
								valueMatched = true
								break
							}
						}

						// Not a single value matched? Return false
						if (!valueMatched) return false
					}
				}

				// Item has passed each filter, include it in the list
				return true
			})
		},
		//take an array of objects and turn it into a primitive array with a key property
		primitize(input, keyProp = "id") {
			return input.map(record => record[keyProp])
		},
		radians(deg) {
			return deg * Math.PI / 180
		},
		getDistance(lat1,long1,lat2,long2) {
			let R = 6378137; // Earth’s mean radius in meter
			let dLat = this.radians(lat2 - lat1);
			let dLong = this.radians(long2 - long1);
			let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(this.radians(lat1)) * Math.cos(this.radians(lat2)) *
			Math.sin(dLong / 2) * Math.sin(dLong / 2);
			let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			let d = R * c;
			return d; // returns the distance in meter
		},
		// ref: http://stackoverflow.com/a/1293163/2343
		// This will parse a delimited string into an array of
		// arrays. The default delimiter is the comma, but this
		// can be overriden in the second argument.
		CSVToArray( strData, strDelimiter ){
			// Check to see if the delimiter is defined. If not,
			// then default to comma.
			strDelimiter = (strDelimiter || ",");

			// Create a regular expression to parse the CSV values.
			var objPattern = new RegExp(
				(
					// Delimiters.
					"(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +

					// Quoted fields.
					"(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

					// Standard fields.
					"([^\"\\" + strDelimiter + "\\r\\n]*))"
				),
				"gi"
				);


			// Create an array to hold our data. Give the array
			// a default empty first row.
			var arrData = [[]];

			// Create an array to hold our individual pattern
			// matching groups.
			var arrMatches = null;


			// Keep looping over the regular expression matches
			// until we can no longer find a match.
			while (arrMatches = objPattern.exec( strData )){

				// Get the delimiter that was found.
				var strMatchedDelimiter = arrMatches[ 1 ];

				// Check to see if the given delimiter has a length
				// (is not the start of string) and if it matches
				// field delimiter. If id does not, then we know
				// that this delimiter is a row delimiter.
				if (
					strMatchedDelimiter.length &&
					strMatchedDelimiter !== strDelimiter
					){

					// Since we have reached a new row of data,
					// add an empty row to our data array.
					arrData.push( [] );

				}

				var strMatchedValue;

				// Now that we have our delimiter out of the way,
				// let's check to see which kind of value we
				// captured (quoted or unquoted).
				if (arrMatches[ 2 ]){

					// We found a quoted value. When we capture
					// this value, unescape any double quotes.
					strMatchedValue = arrMatches[ 2 ].replace(
						new RegExp( "\"\"", "g" ),
						"\""
						);

				} else {

					// We found a non-quoted value.
					strMatchedValue = arrMatches[ 3 ];

				}


				// Now that we have our value string, let's add
				// it to the data array.
				arrData[ arrData.length - 1 ].push( strMatchedValue );
			}

			// Return the parsed data.
			return( arrData );
		},
		CSVToJSON(strData, strDelimiter) {
			let arrData = this.CSVToArray(strData, strDelimiter)

			if (arrData.length > 0) {

				let indexed = []
				arrData[0].forEach((header, index) => {
					indexed[index] = header
				})

				arrData = arrData.slice(1).map(row => {
					let jsonRow = {}
					row.forEach((field, index) => {
						jsonRow[indexed[index]] = field
					})
					return jsonRow
				})

			}

			return arrData
		},
		exportToCSV(filename, rows) {
			var processRow = function (row) {
				var finalVal = '';
				for (var j = 0; j < row.length; j++) {
					var innerValue = row[j] === null ? '' : row[j].toString();
					if (row[j] instanceof Date) {
						innerValue = row[j].toLocaleString();
					};
					var result = innerValue.replace(/"/g, '""');
					if (result.search(/("|,|\n)/g) >= 0)
						result = '"' + result + '"';
					if (j > 0)
						finalVal += ',';
					finalVal += result;
				}
				return finalVal + '\n';
			};

			var csvFile = '';
			for (var i = 0; i < rows.length; i++) {
				csvFile += processRow(rows[i]);
			}

			var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
			if (navigator.msSaveBlob) { // IE 10+
				navigator.msSaveBlob(blob, filename);
			} else {
				var link = document.createElement("a");
				if (link.download !== undefined) { // feature detection
					// Browsers that support HTML5 download attribute
					var url = URL.createObjectURL(blob);
					link.setAttribute("href", url);
					link.setAttribute("download", filename);
					link.style.visibility = 'hidden';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}
			}
		},
		extractHostname(url) {
			var hostname;
			//find & remove protocol (http, ftp, etc.) and get hostname

			if (url.indexOf("//") > -1) {
				hostname = url.split('/')[2];
			}
			else {
				hostname = url.split('/')[0];
			}

			//find & remove port number
			hostname = hostname.split(':')[0];
			//find & remove "?"
			hostname = hostname.split('?')[0];

			return hostname;
		},
		segmentUrl(url) {
			url = url.replace("http://","")
			url = url.replace("https://","")

			return url.split("/")
		},
		buildUrl(segments) {
			return "/"+segments.join("/")
		},
		getUrlQueryParams(url) {
			let split = url.split("?")

			if (split.length < 2)
				return null

			let params = split[1].split("&")

			let keyedParams = {}
			params.forEach(param => {
				let keyValue = param.split("=")

				if (keyValue.length == 2)
					keyedParams[keyValue[0]] = keyValue[1]
			})

			return keyedParams
		},
		addHttp(link) {
			if (link.startsWith('http'))
				return link
			return "http://" + link
		},
		cloneObj(obj) {
			return JSON.parse(JSON.stringify(obj))
		},
		stripProperties(obj,keys) {
			keys.forEach(key => {
				delete obj[key]
			})

			return obj
		},
		getRandomInt(min,max) {
			min = Math.ceil(min);
			max = Math.floor(max);
			return Math.floor(Math.random() * (max - min + 1)) + min;
		},
		renderInlineProgressBar(percentComplete, decimals = 1) {

			let barColor = "#c4c4ff"
			if (percentComplete > 100)
				barColor = "#ffc4c4"

			return "<div style='position:relative;width:100%;height:30px;border:1px solid #c4c4ff;padding:2px'>\
				<div style='position:relative;z-index:2'>"+percentComplete.toFixed(decimals)+"%</div>\
				<div style='position:absolute;top:0;left:0;height:100%;background-color:"+barColor+";width:"+percentComplete+"%;max-width:100%;'></div>\
			</div>"
		},
		copyToClipboard(str,message) {
			// Create new element
			var el = document.createElement('textarea');
			// Set value (string to be copied)
			el.value = str;
			// Set non-editable to avoid focus and move outside of view
			el.setAttribute('readonly', '');
			el.style = {position: 'absolute', left: '-9999px'};
			document.body.appendChild(el);
			// Select text inside element
			el.select();
			// Copy text to clipboard
			document.execCommand('copy');
			// Remove temporary element
			document.body.removeChild(el);

			if (message)
				this.alertSuccess(typeof message == 'string' ? message : "Copied to clipboard")
		},
		/* Get the position of an element relative to the document */
		offset(el) {
			var rect = el.getBoundingClientRect()

			let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop
			return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
		},

		/**
		* The function creates a tree from that list, where each node has the record along with a new field "children" that would in this case have all the subcategories
		*/
		groupRecords(records, parentIdField, idField='id') {

			let newRecords = this.cloneObj(records)
			let idMapping = newRecords.reduce((acc, el, i) => {
				acc[el[idField]] = i;
				return acc;
			}, {});

			let roots = [];

			newRecords.forEach((record) => {

				if (!('children' in record))
					record.children = []

				if (!record[parentIdField] || record[parentIdField] == '0')
					roots.push(record)

				else {

					// Use our mapping to locate the parent category
					let parentCat = newRecords[idMapping[record[parentIdField]]];

					// Add to parent's list of subcategories
					if (parentCat) {
						parentCat.children = [...(parentCat.children || []), record];
					}

				}
			});

			return roots
		},
		toggleFullScreen() {
			if (typeof document.documentElement.requestFullscreen !== 'undefined' && !document.fullscreenElement) {
				document.documentElement.requestFullscreen();
			}
			else if (document.exitFullscreen) {
				document.exitFullscreen();
			}
		},

		async getBase64ImageFromUrl(imageUrl) {
			var res = await fetch(imageUrl);
			var blob = await res.blob();

			return new Promise((resolve, reject) => {
				var reader  = new FileReader();
				reader.addEventListener("load", function () {
					resolve(reader.result);
				}, false);

				reader.onerror = () => {
					return reject(this);
				};
				reader.readAsDataURL(blob);
			})
		}
	}
}